import React, { ErrorInfo } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { showMessage } from '../../Services/ToastService';

interface ErrorBoundaryProps {
  children: React.ReactNode;
  intl: IntlShape;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error?: any;
}

class ErrorBoundary extends React.PureComponent<ErrorBoundaryProps, ErrorBoundaryState> {
  state: Readonly<ErrorBoundaryState> = {
    hasError: false,
  };

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // You can also log the error to an error reporting service
    console.info(error, errorInfo);
  }

  render() {
    const { formatMessage: f } = this.props.intl;
    if (this.state.hasError) {
      showMessage(f({ id: 'toastr.errorTitle' }), f({ id: 'toastr.errorBoundaryText' }), 'error');
      return false;
    }

    return this.props.children;
  }
}

// eslint-disable-next-line react-refresh/only-export-components
export default injectIntl(ErrorBoundary);
